var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopNavbar'),(_vm.fetchedData)?_c('DescriptionServices',{attrs:{"datos":_vm.datos}}):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }